import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useFlowStore } from '@src/pages/workflow/store/flowBuilder';
import { useNavigate } from 'react-router-dom';

const { confirm } = Modal;

const ClipboardOnFocus = () => {
  const [clipboardText, setClipboardText] = useState('');
  const [isFirstCheck, setIsFirstCheck] = useState(true);

  const setSelectedFlow = useFlowStore((s) => s.setSelectedFlow);
  const navigate = useNavigate();

  const checkClipboardText = (text) => {
    // validate text
    // {
    //   source: 'gm',
    //   target: 'activation',
    //   key: 'flow',
    //   id: 121312312312,
    //   data: {},
    // }
    return !!(text.includes(`"target": "activation"`) && text.includes(`"key": "flow"`));
  };

  const getFlowDataFromClipboardText = (text) => {
    try {
      const obj = JSON.parse(text);
      return obj.data;
    } catch (e) {
      console.log('Parse clipboard text error: ', e);
    }
  };

  const showConfirm = useCallback(
    (text) => {
      const flowData = getFlowDataFromClipboardText(text);
      if (flowData) {
        Modal.destroyAll();

        confirm({
          title: 'Do you want to activate this flow?',
          icon: <ExclamationCircleFilled />,
          content: flowData.name,
          onOk() {
            setClipboardText(text);
            setSelectedFlow(flowData);
            navigate(`/workflow/flow/new`);
          },
          onCancel() {
            setClipboardText(text);
          },
        });
      }
    },
    [setSelectedFlow],
  );

  useEffect(() => {
    const handleFocus = async () => {
      try {
        if (navigator.clipboard && navigator.clipboard.readText) {
          const text = await navigator.clipboard.readText();
          const isValidText = checkClipboardText(text);
          // if (isValidText && text !== clipboardText) {
          if (isValidText) {
            showConfirm(text);
          }
        } else {
          console.warn('No Clipboard API');
        }
      } catch (err) {
        console.error('Read clipboard failed:', err);
      }
    };

    if (isFirstCheck) {
      // handleFocus();
      setIsFirstCheck(false);
    }

    window.addEventListener('paste', handleFocus);
    // window.addEventListener('focus', handleFocus);
    return () => {
      // window.removeEventListener('focus', handleFocus);
      window.removeEventListener('paste', handleFocus);
    };
  }, [clipboardText, showConfirm, isFirstCheck]);

  return null;
};

export default ClipboardOnFocus;
